import { OrganizationIdsGuard } from '@/features/authentication/_components/OrganizationIdsGuard';
import type { FC } from 'react';
import { Route, Routes } from 'react-router';
import CommentListPage from './pages/CommentListPage';
import NotFoundPage from './pages/NotFoundPage';

export const CommentRoutes: FC = () => {
  return (
    <OrganizationIdsGuard showDenied>
      <Routes>
        <Route index element={<CommentListPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </OrganizationIdsGuard>
  );
};
